export const steps = [
    {
        title: 'Выберите изделия для печати',
        name: 'Изделие',
        columns: 2,
        columnsWidth: '1fr',
        type: 'checkbox',
        autoskip: false,
        tip: 'Можно выбрать <b>несколько изделий</b>',
        items: [
            {
                label: 'футболки'
            },
            {
                label: 'шопперы'
            },
            {
                label: 'толстовки (худи)',
                value: 'толстовки',
            },
            {
                label: 'кружки'
            },
            {
                label: 'поло'
            },
            {
                label: 'тарелки'
            },
            {
                label: 'свитшоты'
            },
            {
                label: 'бейсболки'
            },
            {
                label: 'спецодежда'
            },
            {
                label: 'обувь',
            },
            {
                label: 'майки',
            },
            {
                label: 'что-то другое',
                value: 'другое',
            },
        ]

    },
    {
        title: 'Выберите примерные размеры принтов',
        name: 'Размеры',
        columns: 2,
        columnsWidth: '1fr',
        type: 'checkbox',
        autoskip: false,
        tip: 'Можно выбрать несколько из доступных',
        items: [
            {
                label: '<b>А2</b> &nbsp;(59х40 см)',
                value: 'А2',
                dependsOn: 'Изделие',
                requirements: ['футболки', 'толстовки', 'поло', 'свитшоты', 'спецодежда', 'другое'],
            },
            {
                label: '<b>А3</b> &nbsp;(42х30 см)',
                value: 'А3',
                dependsOn: 'Изделие',
                requirements: ['футболки', 'толстовки', 'поло', 'свитшоты', 'спецодежда', 'шопперы', 'майки', 'другое'],
            },
            {
                label: '<b>А4</b> &nbsp;(30х21 см)',
                value: 'А4',
                dependsOn: 'Изделие',
                requirements: ['футболки', 'толстовки', 'поло', 'свитшоты', 'спецодежда', 'шопперы', 'майки', 'другое'],
            },
            {
                label: '<b>А5</b> &nbsp;(21x15 см)',
                value: 'А5',
                dependsOn: 'Изделие',
                requirements: ['футболки', 'толстовки', 'поло', 'свитшоты', 'спецодежда', 'шопперы', 'бейсболки', 'майки', 'тарелки', 'другое'],
            },
            {
                label: '<b>А6</b> &nbsp;(15x10 см)',
                value: 'А6',
            },
        ]
    },
    {
        title: 'Выберите общее количество изделий',
        name: 'Количество',
        columns: 2,
        columnsWidth: '1fr',
        type: 'radio',
        autoskip: true,
        tip: 'Укажите общий тираж <b>всех изделий</b>',
        items: [
            {
                label: '1 — 2',
                value: '1-2',
            },
            {
                label: '3 — 10',
                value: '3-10',
            },
            {
                label: '11 — 30',
                value: '11-30',
            },
            {
                label: '31 — 50',
                value: '31-50',
            },
            {
                label: '51 — 100',
                value: '51-100',
            },
            {
                label: 'более 100',
                value: '100+',
            },
        ]
    },
]